import {
  Flex,
  Image,
  JaneGoldIcon,
  PartnerLogo,
  Typography,
} from '@iheartjane/reefer';

import { Container, ImageArea, TextArea } from './SpecialCard.styles';

interface SpecialCardBaseProps {
  discountLabel: string;
  onSpecialsClick(): void;
  specialPhoto?: string | null;
  title: string;
}

export interface StoreSpecialCardProps extends SpecialCardBaseProps {
  storeSpecialType: string;
  variant: 'store';
}

export interface BrandSpecialCardProps extends SpecialCardBaseProps {
  brandName: string;
  partnerLogo?: string | null;
  subHeader?: string | null;
  variant: 'brand';
}

export type SpecialCardProps = BrandSpecialCardProps | StoreSpecialCardProps;

export const SpecialCard = ({
  discountLabel,
  onSpecialsClick,
  specialPhoto,
  title,
  variant,
  ...props
}: SpecialCardProps) => {
  const isStoreSpecial = 'storeSpecialType' in props;

  return (
    <Container
      flexDirection="column"
      justifyContent="flex-end"
      ariaLabel={`${title} ${variant} special card`}
      onClick={onSpecialsClick}
    >
      {specialPhoto ? (
        <Image
          height="130px"
          src={specialPhoto}
          altText={`${title} special photo`}
          responsive
          sizes="card"
          data-testid="store-special-photo"
        />
      ) : (
        <ImageArea
          variant={variant}
          height="130px"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          gap={8}
        >
          {!isStoreSpecial && <JaneGoldIcon size="md" />}
          <Typography
            color={isStoreSpecial ? 'grays-white' : 'grays-black'}
            variant="header-bold"
          >
            {discountLabel}
          </Typography>
        </ImageArea>
      )}

      <TextArea
        flexDirection="row"
        px={24}
        py={16}
        gap={12}
        width="100%"
        grow={1}
      >
        {!isStoreSpecial && (
          <PartnerLogo
            variant="brand"
            size="xxs"
            image={props?.partnerLogo}
            name={props.brandName}
          />
        )}
        <Flex flexDirection="column" width="100%" overflow="hidden">
          <Typography
            color={isStoreSpecial ? 'sunset' : 'grays-black'}
            variant="mini"
            truncateAt="100%"
          >
            {isStoreSpecial
              ? props.storeSpecialType
              : `${props.brandName}${props.subHeader ? ` • ${props.subHeader}` : ''}`}
          </Typography>
          <Typography variant="body-bold" maxLines={2}>
            {title}
          </Typography>
        </Flex>
      </TextArea>
    </Container>
  );
};
